export const SECTION_LABEL_SX = {
  fontSize: 'var(--sidebar-font-xs)',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: 'var(--sidebar-tertiary)',
};

export const INFO_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: '92px 1fr',
  columnGap: '12px',
  rowGap: '7px',
};

export const INFO_GRID_LABEL_SX = {
  fontSize: 'var(--sidebar-font-base)',
  color: 'var(--sidebar-tertiary)',
  fontWeight: 600,
};

export const INFO_GRID_VALUE_SX = {
  fontSize: 'var(--sidebar-font-base)',
  color: 'var(--sidebar-body)',
};
